var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('modal-info',{attrs:{"html":_vm.html}}),_c('div',{staticClass:"column is-6 is-offset-3"},[_c('formulario-inscripcion-2')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }